import { render, staticRenderFns } from "./DashboardPreview.vue?vue&type=template&id=6771ac68&scoped=true&"
import script from "./DashboardPreview.ts?vue&type=script&lang=ts&"
export * from "./DashboardPreview.ts?vue&type=script&lang=ts&"
import style0 from "./DashboardPreview.scss?vue&type=style&index=0&id=6771ac68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6771ac68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCol,VIcon})
